!(function () {
  "use strict";
  const TEMPLATE_SELECTOR = "[data-video-template]";
  const MOBILE_TEMPLATE_SELECTOR = "[data-mobile-video-template]";
  const LOADING_CLASS = "is-loading";
  const VIDEO_ID_ATTR = "data-video-id";
  const MOBILE_MQ = window.matchMedia("(max-width: 767px)");

  customElements.get("video-background") ||
    customElements.define(
      "video-background",
      class extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.videoId = this.getAttribute(VIDEO_ID_ATTR);
          this.videoTemplate = this.querySelector(TEMPLATE_SELECTOR);
          this.mobileVideoTemplate = this.querySelector(MOBILE_TEMPLATE_SELECTOR);
          this.video = null;
          this.powerSaverVideoPlay = this.powerSaverVideoPlay.bind(this);

          if (this.mobileVideoTemplate) {
            this._onMqChange = () => this._switchVideo();
            MOBILE_MQ.addEventListener("change", this._onMqChange);
          }

          if (this.videoId) this.renderVideo();
        }

        _activeTemplate() {
          if (this.mobileVideoTemplate && MOBILE_MQ.matches) {
            return this.mobileVideoTemplate;
          }
          return this.videoTemplate;
        }

        _switchVideo() {
          this.videoPlayObserver?.disconnect();
          this.video?.pause();
          this.video = null;
          this.innerHTML = "";
          this.classList.add(LOADING_CLASS);

          const html = this._activeTemplate().innerHTML;
          this.innerHTML = html;
          this.classList.remove(LOADING_CLASS);
          this.video = this.querySelector("video");
          this.observeVideoPlayToggle();
          this.video?.play().catch(() => {});
        }

        powerSaverVideoPlay() {
          this.video?.play();
        }

        renderVideo() {
          const rect = this.getBoundingClientRect();
          const style = window.getComputedStyle(this);
          const isHidden = style.visibility === "hidden" || style.display === "none";
          const isInitiallyVisible = !isHidden && rect.top < window.innerHeight && rect.bottom > 0;

          if (isInitiallyVisible) {
            this._renderAndPlay();
            return;
          }

          this.videoTemplateObserver = new IntersectionObserver(
            (entries, observer) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                const entryStyle = window.getComputedStyle(entry.target);
                if (entryStyle.visibility === "hidden" || entryStyle.display === "none") return;

                this._renderAndPlay();
                observer.unobserve(entry.target);
              });
            },
            {
              root: null,
              rootMargin: "300px",
              threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
            },
          );
          requestAnimationFrame(() => this.videoTemplateObserver.observe(this));
        }

        _renderAndPlay() {
          const html = this._activeTemplate().innerHTML;
          this.innerHTML = html;
          this.classList.remove(LOADING_CLASS);
          this.video = this.querySelector("video");
          this.observeVideoPlayToggle();
          this.video
            .play()
            .then(() => {})
            .catch(() => {
              document.addEventListener("click", this.powerSaverVideoPlay, {
                passive: true,
                bubbles: true,
                once: true,
              });
              document.addEventListener("touchstart", this.powerSaverVideoPlay, {
                passive: true,
                bubbles: true,
                once: true,
              });
            });
        }

        observeVideoPlayToggle() {
          if (!this.video) return;
          this.videoPlayObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const visible = entry.isIntersecting;
                if (visible && typeof this.video.play === "function") {
                  this.video.play().catch(() => {});
                } else if (!visible && typeof this.video.pause === "function") {
                  this.video.pause();
                }
              });
            },
            { rootMargin: "0px", threshold: [0, 1] },
          );
          this.videoPlayObserver.observe(this.video);
        }

        disconnectedCallback() {
          this.videoTemplateObserver?.disconnect();
          this.videoPlayObserver?.disconnect();
          if (this._onMqChange) {
            MOBILE_MQ.removeEventListener("change", this._onMqChange);
          }
          if (this.videoId) {
            document.removeEventListener("click", this.powerSaverVideoPlay);
            document.removeEventListener("touchstart", this.powerSaverVideoPlay);
          }
        }
      },
    );
})();
